import { createSlice } from '@reduxjs/toolkit';
import { completeRemainingTickets, downloadRemainingTickets, getRemainingTickets } from './ticketService';

const initialState = {
    remainingTickets: {
        isRemainingTicketsLoading: null,
        isRemainingTicketsSuccess: null,
        pageCount: 0,
        tickets: [],
        ticketsCount: 0,
    },
    remainingTicektFile: {
        isFileDownloading: null,
        fileDownloadedMsg: null,
        isFileDownloadSuccess: null
    },
    completeRemainingLottery: {
        isCompleting: null,
        completedMsg: null,
        isCompleteSuccess: null
    }
};

const ticketSlice = createSlice({
    name: 'ticket',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getRemainingTickets.pending, (state) => {
            state.remainingTickets = {
                ...initialState.remainingTickets,
                isRemainingTicketsLoading: true,
            };
        });

        builder.addCase(getRemainingTickets.rejected, (state) => {
            state.remainingTickets = {
                ...initialState.remainingTickets,
                isRemainingTicketsLoading: false,
                isRemainingTicketsSuccess: false,
            };
        });

        builder.addCase(getRemainingTickets.fulfilled, (state, action) => {
            state.remainingTickets = {
                ...initialState.remainingTickets,
                isRemainingTicketsLoading: false,
                isRemainingTicketsSuccess: true,
                pageCount: action.payload.pageCount || 0,
                tickets: action.payload.data || [],
                ticketsCount: action.payload.count || 0,
            };
        });

        //Coemplete Tickets
        builder.addCase(completeRemainingTickets.pending, (state) => {
            state.completeRemainingLottery = {
                ...initialState.completeRemainingLottery,
                isCompleting: true,
            };
        });

        builder.addCase(completeRemainingTickets.rejected, (state, action) => {
            state.completeRemainingLottery = {
                ...initialState.completeRemainingLottery,
                isCompleting: false,
                completedMsg: action.payload.message,
                isCompleteSuccess: false
            };
        });

        builder.addCase(completeRemainingTickets.fulfilled, (state, action) => {
            state.completeRemainingLottery = {
                ...initialState.completeRemainingLottery,
                isCompleting: false,
                completedMsg: action.payload.message,
                isCompleteSuccess: true
            };
        });

        //Download Tickets
        builder.addCase(downloadRemainingTickets.pending, (state) => {
            state.remainingTicektFile = {
                ...initialState.remainingTicektFile,
                isFileDownloading: true,
            };
        });

        builder.addCase(downloadRemainingTickets.rejected, (state, action) => {
            state.remainingTicektFile = {
                ...initialState.remainingTicektFile,
                isFileDownloading: false,
                fileDownloadedMsg: action.payload.message,
                isFileDownloadSuccess: false
            };
        });

        builder.addCase(downloadRemainingTickets.fulfilled, (state, action) => {
            state.remainingTicektFile = {
                ...initialState.remainingTicektFile,
                isFileDownloading: false,
                fileDownloadedMsg: action.payload.message,
                isFileDownloadSuccess: true
            };
        });
    },
});

export default ticketSlice.reducer;
